import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import { showErrorMessage } from "@my-dld/utils/UIUtils";
import Strings from "@my-dld/assets/strings";
import { I8N } from "@eres/core";
import ListGridDataView from "@my-dld/components/DataView/ListGridDataView";
import { getExternalValuationStatusClass, ValuationRequest } from "../../../valuationapi/entities";
import EVRequestsListView from "@my-dld/components/MyRequest/EVRequestsListView";
import EVRequestsGridView from "@my-dld/components/MyRequest/EVRequestsGridView";
import { ExternalValuationApi } from "../../../valuationapi";
import { navigate } from "@my-dld/utils/StoreUtils";

interface Props extends RoutedViewProps {

}

interface State {
	isLoading: boolean;
	evRequests: ValuationRequest[];
}

class ExternalValuationRequests extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			isLoading: true,
			evRequests: [],
		};
	}

	componentDidMount() {
		this.loadEVRequests();
	}

	render() {
		const { isLoading } = this.state;
		return <ListGridDataView
			isLoading={ isLoading }
			title={ Strings.external_valuation }
			renderListView={ this.renderListView }
			renderGridView={ this.renderGridView }/>;
	}

	private renderListView = () => {
		const { evRequests } = this.state;
		return <EVRequestsListView
			items={ evRequests } onDetails={ ( req ) => {
			this.onDetails( req );
		}
		}/>;
	};

	private renderGridView = () => {
		const { evRequests } = this.state;
		return <EVRequestsGridView
			items={ evRequests } onDetails={ ( req ) => {
			this.onDetails( req );
		}
		}/>;
	};

	private loadEVRequests() {
		ExternalValuationApi.getOwnerRequests().then( ( resp: any ) => {
			if ( resp.validationErrorsList && resp.validationErrorsList.length > 0 ) {
				showErrorMessage( ExternalValuationApi.getValidationError( resp.validationErrorsList ) );
				this.setState( { isLoading: false } );
			} else {
				this.setState( {
					evRequests: resp.response ? resp.response.request : [],
					isLoading: false
				} );
			}
		} ).catch( reason => {
			this.setState( { isLoading: false } );
			showErrorMessage( reason );
		} );
	}

	private onDetails = ( item: ValuationRequest ) => {
		// trackEventWithData("RVS", "ViewTransactionDetails",
		//     { transactionNo: complaint.TransactionNumber });
		navigate( `/mydld/valuation_details/${ item.requestId }` );
	};

}

export function getEVReqNo( item: ValuationRequest ) {
	return item.requestNumber;
}

export function getEVReqCommitteeStatus( item: ValuationRequest ) {
	const val = I8N.isRTL() ? item.requestStatusNameAr : item.requestStatusNameEn;
	return val ? val : "";
}

export function getEVReqStatusClass( item: ValuationRequest ) {
	return getExternalValuationStatusClass( item );
}


export default ExternalValuationRequests;
